import getList from './getList';
import getDomainList from './getDomainList';
import getGroupList from './getGroupList';
import add from './add';
import edit from './edit';
import del from './del';
import getModules from './getModules';
import getRoleList from './getRoleList';
import getPermissionList from './getPermissionList';
import delRole from './delRole';
import addRole from './addRole';
import editRole from './editRole';
import editRolePermissions from './editRolePermissions';
export default {
  getList,
  getDomainList,
  getGroupList,
  edit,
  add,
  del,
  getModules,
  getRoleList,
  delRole,
  addRole,
  editRole,
  getPermissionList,
  editRolePermissions,
};


// WEBPACK FOOTER //
// ./src/api/usermanager/index.ts